export const TEST_ID = 'farmDetailsPage';

export const CARD_HEADER_DETAIL_TYPE = 'farm';

export const CLIENT_DETAILS_PAGE_ROUTE = '/data/clientDetails';

export const DETAIL_TYPE_CLIENT = 'client';

export const DETAIL_TYPE_FIELD = 'field';
